const VirtualMuseumMain = () => {
    return (
        <div>
            VIRTUAL MUSEUM MAIN PAGE
        </div>
    )
};

export default VirtualMuseumMain;